import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function TransactionSideCardRow({ borderBottom, borderTop, label, value }) {
  return (
    <div
      className={classNames('d-flex gap-2 pb-3', {
        'mb-3 border-bottom': borderBottom,
        'pt-3 border-top': borderTop,
      })}
    >
      <label className="form-label flex-fill">{label}</label>
      <span>{value}</span>
    </div>
  );
}

TransactionSideCardRow.propTypes = {
  borderBottom: PropTypes.bool,
  borderTop: PropTypes.bool,
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};
